var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image_saver_view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !(
                (_vm.item.list.length == 0 && _vm.itemsLength == 1) ||
                _vm.isShowCard
              ),
              expression:
                "!((item.list.length==0 && itemsLength==1)||isShowCard)"
            }
          ],
          staticClass: "image_saver_view_title"
        },
        [
          _c(
            "div",
            { staticClass: "image_saver_view_icon", style: _vm.faviconStyle },
            [
              _c("img", {
                ref: "faviconIcon",
                staticClass: "image_saver_view_favicon",
                attrs: { src: _vm.item.favicon },
                on: {
                  error: function($event) {
                    return _vm.faviconError($event, _vm.item.source)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "image_saver_view_domain" }, [
            _vm._v(
              _vm._s(
                (_vm.item.type == "google" ? "Google Search Images -- " : "") +
                  _vm.item.domain
              ) +
                " - " +
                _vm._s(
                  _vm.item.typeSub == "posts" && _vm.item.posts
                    ? _vm.postsUnitText(_vm.item.posts)
                    : _vm.filesUnitText(_vm.item.list.length)
                )
            )
          ]),
          _vm._v(" "),
          _vm.item.list.length > 0
            ? _c(
                "div",
                {
                  staticClass: "image_saver_view_download_all",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.downloads($event)
                    }
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isDownloadAllRequest,
                        expression: "isDownloadAllRequest"
                      }
                    ],
                    staticClass: "my_animation",
                    attrs: {
                      src: require("../../assets/images/imageSaver/loadingBlue.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isDownloadAllRequest,
                        expression: "!isDownloadAllRequest"
                      }
                    ],
                    attrs: {
                      src: require("../../assets/images/imageSaver/downloadAll.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.imageSaver.downloadAll")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.list.length > 0
            ? _c(
                "div",
                {
                  staticClass: "image_saver_view_save_all",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.saveAll($event)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/images/imageSaver/saveAll.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.imageSaver.saveAll")))
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item.list.length > 0,
              expression: "item.list.length>0"
            }
          ],
          staticClass: "image_saver_view_imgs",
          style: {
            minHeight: _vm.imgsBoxMinHeight + "px",
            maxHeight: _vm.imgsBoxMaxHeight + "px",
            padding: "10px 30px 10px 30px"
          },
          attrs: { "data-ivs": _vm.isVerticalScreen ? "Y" : "N" }
        },
        [
          _vm.isShowCard
            ? _c(
                "div",
                {
                  staticClass: "ins_card",
                  attrs: {
                    "data-loading": _vm.item.loading ? "Y" : "N",
                    "data-error": _vm.item.isError ? "Y" : "N"
                  }
                },
                [
                  _c("div", { staticClass: "ins_card_user_icon" }, [
                    _c("img", { attrs: { src: _vm.item.favicon } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ins_card_mask" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ins_card_icon_save",
                        on: {
                          click: function($event) {
                            return _vm.saveAvatar()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.imageSaver.saveToCloud"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ins_card_icon_download",
                        on: {
                          click: function($event) {
                            return _vm.downloadAvatar()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.imageSaver.download")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ins_card_user_info" }, [
                    _c("div", { staticClass: "ins_card_username" }, [
                      _vm._v(_vm._s(_vm.item.domain))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ins_card_user_count" }, [
                      _c("div", { staticClass: "ins_card_user_posts" }, [
                        _c("div", { staticClass: "ins_card_user_num" }, [
                          _vm._v(
                            _vm._s(
                              _vm.item.posts == undefined ? "-" : _vm.item.posts
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ins_card_user_text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.imageSaver.insCardPosts"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ins_card_user_followers" }, [
                        _c("div", { staticClass: "ins_card_user_num" }, [
                          _vm._v(
                            _vm._s(
                              _vm.item.followed == undefined
                                ? "-"
                                : _vm.item.followed
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ins_card_user_text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.imageSaver.insCardFollowers")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ins_card_user_following" }, [
                        _c("div", { staticClass: "ins_card_user_num" }, [
                          _vm._v(
                            _vm._s(
                              _vm.item.follow == undefined
                                ? "-"
                                : _vm.item.follow
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ins_card_user_text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.imageSaver.insCardFollowing")
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ins_card_btns" }, [
                      _c(
                        "div",
                        {
                          staticClass: "ins_card_save_all",
                          on: { click: _vm.saveAll }
                        },
                        [_vm._v(_vm._s(_vm.saveAllBtnText))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ins_card_downlad_all",
                          on: { click: _vm.downloads }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.downloadAllBtnText + _vm.insCountStr)
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.isShowInsTab
                    ? _c("div", { staticClass: "ins_card_types_no" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowInsTab
                    ? _c("div", { staticClass: "ins_card_types" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ins_card_type_posts",
                            class: _vm.insTypeSelect == "posts" ? "select" : "",
                            on: {
                              click: function($event) {
                                return _vm.selectInsType(_vm.index, "posts")
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.imageSaver.insTabPosts")
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ins_card_type_reels",
                            class: _vm.insTypeSelect == "reels" ? "select" : "",
                            on: {
                              click: function($event) {
                                return _vm.selectInsType(_vm.index, "reels")
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.imageSaver.insTabReels")
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ins_card_type_stories",
                            class:
                              _vm.insTypeSelect == "stories" ? "select" : "",
                            on: {
                              click: function($event) {
                                return _vm.selectInsType(_vm.index, "stories")
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.imageSaver.insTabStories")
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ins_card_type_highlights",
                            class:
                              _vm.insTypeSelect == "highlights" ? "select" : "",
                            on: {
                              click: function($event) {
                                return _vm.selectInsType(
                                  _vm.index,
                                  "highlights"
                                )
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.imageSaver.insTabHighlights")
                                )
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.isError
            ? _c(
                "div",
                {
                  staticClass: "ins_sub_error",
                  style: { height: _vm.noImageHeight - 402 + "px" }
                },
                [
                  _c("div", { staticClass: "ins_sub_error_content" }, [
                    _vm.item.msg != "no_data"
                      ? _c("img", {
                          attrs: {
                            draggable: "false",
                            src: require("../../assets/images/imageSaver/previewError.svg")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.msg == "no_data"
                      ? _c("img", {
                          attrs: {
                            draggable: "false",
                            src: require("../../assets/images/imageSaver/imageNo.svg")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.item.msg == "no_data"
                            ? _vm.$t("language.imageSaver.noImage")
                            : "Loading failed"
                        )
                      )
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.loading
            ? _c(
                "div",
                {
                  staticClass: "ins_sub_loading",
                  style: { height: _vm.noImageHeight - 402 + "px" }
                },
                [_c("div", { staticClass: "ins_sub_loading_icon" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.pageIndex > 1
            ? _c("div", { staticClass: "page_up" }, [
                _c(
                  "button",
                  { staticClass: "page_up_btn", on: { click: _vm.pageUp } },
                  [_vm._v("Previous")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.listSub, function(bean) {
            return !_vm.item.loading && !_vm.item.isError
              ? _c(
                  "div",
                  {
                    staticClass: "image_saver_view_img",
                    attrs: {
                      "data-status": bean.status,
                      "data-type": bean.type,
                      "data-canplay": bean.canplay
                    },
                    on: {
                      mouseenter: function($event) {
                        return _vm.enterVideoPreview(bean)
                      },
                      mouseleave: function($event) {
                        return _vm.leaveVideoPreview(bean)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "view",
                      class: "imagesaver_" + _vm.item.type,
                      style: {
                        width: _vm.viewImgWigth + "px",
                        height:
                          _vm.viewImgWigth +
                          (_vm.isVerticalScreen ? 200 : 0) +
                          "px"
                      },
                      attrs: {
                        src: _vm.isPreview
                          ? bean.preview
                            ? bean.preview.data
                            : _vm.previewInsImg
                          : bean.url
                      },
                      on: {
                        error: function($event) {
                          return _vm.previewError($event, bean)
                        },
                        load: function($event) {
                          return _vm.imgLoadSucess(bean)
                        }
                      }
                    }),
                    _vm._v(" "),
                    bean.type == "video" && bean.videoPreview
                      ? _c(
                          "video",
                          {
                            staticClass: "preview_error video_preview",
                            attrs: { autoplay: "", loop: "" },
                            on: {
                              canplay: function($event) {
                                return _vm.handleCanplay(bean)
                              }
                            }
                          },
                          [
                            _c("source", {
                              attrs: {
                                src: bean.videoPreview,
                                type: "video/mp4"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-skeleton",
                      {
                        staticClass: "preview_error skeleton",
                        attrs: { animated: "" }
                      },
                      [
                        _c(
                          "template",
                          { slot: "template" },
                          [
                            _c("el-skeleton-item", {
                              style: {
                                width: _vm.viewImgWigth + "px",
                                height:
                                  _vm.viewImgWigth +
                                  (_vm.isVerticalScreen ? 200 : 0) +
                                  "px"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "preview_error mask" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "preview_error save",
                      on: {
                        click: function($event) {
                          return _vm.save(bean)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "preview_error text_upload",
                        on: {
                          click: function($event) {
                            return _vm.save(bean)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.imageSaver.saveToCloud"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "preview_error download",
                      on: {
                        click: function($event) {
                          return _vm.download(bean)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "preview_error text_download",
                        on: {
                          click: function($event) {
                            return _vm.download(bean)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.imageSaver.download")))]
                    ),
                    _vm._v(" "),
                    bean.type == "video"
                      ? _c("div", { staticClass: "preview_error type_video" })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.item.next || _vm.canClickLoadMore
            ? _c("div", { staticClass: "load_more_box" }, [
                _vm.item.type == "instagram"
                  ? _c(
                      "button",
                      { staticClass: "loadMore", on: { click: _vm.loadMore } },
                      [
                        _vm.isLoading
                          ? _c("img", {
                              staticClass: "my_animation",
                              attrs: {
                                src: require("../../assets/images/imageSaver/loadingBlue.png")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("language.imageSaver.loadMore")))
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.item.list.length == 0
        ? _c(
            "div",
            {
              staticClass: "image_saver_view_blank",
              style: { height: _vm.noImageHeightFinally + "px" }
            },
            [
              _c("div", { staticClass: "image_saver_view_blank_body" }, [
                _c("img", {
                  attrs: {
                    draggable: "false",
                    src: require("../../assets/images/imageSaver/imageNo.svg")
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "image_saver_view_blank_body_text" }, [
                  _vm._v(_vm._s(_vm.$t("language.imageSaver.noImage")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "image_saver_view_blank_body_dest" }, [
                  _vm._v(_vm._s(_vm.$t("language.imageSaver.notSupport")))
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transferAimsDialog", { ref: "transferAimsDialog" }),
      _vm._v(" "),
      _c("upgradeVipDialog", { ref: "upgradeVipDialog" }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75143d86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75143d86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/image_saver_view.vue
// module id = null
// module chunks = 